// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__YsjkZ","dragIcon":"Choice_dragIcon__20s3w","left":"Choice_left__2RBzR","input":"Choice_input__1acH5"};